import React from 'react'
import './KeyFocusArea.css'

const icons = {
    road: <i className="fa fa-road" />,
    Road: <i className="fa fa-road" />,
    rail: <i className="fa fa-train" />,
    Rail: <i className="fa fa-train" />,
    ocean: <i className="fa fa-ship" />,
    Ocean: <i className="fa fa-ship" />,
    air: <i className="fa fa-plane" />,
    Air: <i className="fa fa-plane" />,
}

const KeyFocusArea = ({ transporter_data }) => {
    const modeOfOperations = transporter_data?.modes_of_operation ?? []
    const modeOfTransportation = transporter_data?.modes_of_transportation ?? []
    const businessDomain = transporter_data?.domain_business ?? []

    return (
        <div>
            <span className="data_header">Key Focus Area</span>
            <div className="row">
                <div className="col-md-6 modes">
                    <b className="text-center modeHeder">Mode of Transportation</b>
                    {modeOfTransportation.length === 0 ? (
                        <div className="row">
                            <div className="col-12">Details not available</div>
                        </div>
                    ) : (
                        modeOfTransportation.map((mode, i) => (
                            <p key={i}>
                                <b className="mode_name"> {icons[mode.name]}   {mode.name} </b><br />
                                {mode.values && mode.values.length > 0 && mode.values.map((value, index) => (
                                    <div key={index}>
                                        - <span className="mode_percentage"> {value} </span><br />
                                    </div>
                                ))}
                            </p>
                        ))
                    )}
                </div>
                <div className="col-md-6 modes">
                    <b className="text-center modeHeder">Mode of Operations</b>
                    {modeOfOperations.length === 0 ? (
                        <div className="row">
                            <div className="col-12">Details not available</div>
                        </div>
                    ) : (
                        modeOfOperations.map((mode, index2) => (
                            <p key={index2}>
                                -  <b className="mode_name"> {mode.name} </b> :{' '}
                                <span className="mode_percentage">
                                    {mode.percentage ? `${mode.percentage}%` : '-'}
                                </span>
                            </p>
                        ))
                    )}
                </div>
            </div>
            <div className="col-md">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <b className="text-center modeHeder">Business Domain</b>
                    {businessDomain.length === 0 ? (
                        <div className="row">
                            <div className="col-12">Details not available</div>
                        </div>
                    ) : (
                        businessDomain.map((domain, index) => <div key={index}>{domain}</div>)
                    )}
                </div>
            </div>
        </div>
    )
}

export default KeyFocusArea
